module.exports = __webpack_public_path__ + "img/beauty-services-calendar.3d8574b.svg";